import React from 'react';
import sAction from 'sAction';
import LoginForm_orig from 'ROOT/src/components/login/LoginForm';

export default class LoginForm extends LoginForm_orig {
    render() {
        return (
            <>
                <div className="loginBoxContainer" onKeyDown={(e) => this.onKeyDown(e)}>
                    <h1 className="loginHeadline">
                        Impact Forecasting<br/>
                        Support Site
                    </h1>

                    <div className="loginInputWrapper">
                        <label>Username</label>
                        <input type="text" className="loginInput" placeholder="" ref={this.name} />
                    </div>

                    <div className="loginInputWrapper">
                        <label>Password</label>
                        <input type="password" className="loginInput" placeholder="" ref={this.pass} />
                    </div>

                    <div className="signInBtnWrapper">
                        <a className="button full signInBtn" onClick={() => this.submit()}>
                            {sAction.translate('LBL_LOGIN', 'default')}
                        </a>
                    </div>

                    <a className="resetPasswdLink" onClick={() => this.props.goToResetPassword()}>
                        {sAction.translate('LBL_FORGOTTEN_PASSWORD')}
                    </a>

                    <div className="signInBtnWrapper">
                        <a className="button outlined reqestAccesBtn"
                            onClick={() => this.props.goToRequestAccess()}>
                            Request Access
                        </a>
                    </div>
                </div>
            </>
        );
    }
}
